(function () {
  var webhookUrl = window.theme && window.theme.zapierWebhookUrl;
  if (!webhookUrl) return;

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/contact"]')) return;

    var data = {};
    var fields = new FormData(form);
    fields.forEach(function (value, key) {
      if (key === "form_type" || key === "utf8" || key === "_method") return;
      data[key] = value;
    });
    data["page_url"] = window.location.href;
    data["page_title"] = document.title;

    fetch(webhookUrl, {
      method: "POST",
      body: new URLSearchParams(data),
      keepalive: true,
    }).catch(function () {});
  });
})();
